(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-bundles"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initCompactBundles() {
    document.querySelectorAll('[data-fc-bundles] .fc-bd__more').forEach((button) => {
      if (button.dataset.fcReady === '1') return;
      const card = button.closest('[data-fc-slide]');
      if (!card) return;
      const panels = Array.from(card.querySelectorAll('.fc-bd__desc, .fc-kit'));
      if (!panels.length) return;
      button.dataset.fcReady = '1';
      button.setAttribute('aria-controls', panels.map((panel) => panel.id).join(' '));
      button.setAttribute('aria-expanded', 'false');
      card.dataset.fcExpanded = 'false';
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = card.dataset.fcExpanded !== 'true';
        card.dataset.fcExpanded = String(expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.fcLess : button.dataset.fcMore;
      });
    });
  }
  initCompactBundles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompactBundles, { once: true });
  }
  document.addEventListener('shopify:section:load', initCompactBundles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile_menu"]) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('.mb-scroll-panel #mobile_menu').forEach((menu) => {
      menu.querySelectorAll('.mb-has-children').forEach((item, index) => {
        if (item.dataset.mbReady === 'true') return;
        const submenu = item.querySelector(':scope > ul');
        const link = item.querySelector(':scope > a');
        if (!submenu || !link) return;
        item.dataset.mbReady = 'true';
        const initiallyOpen = item.parentElement === menu.querySelector('#menu_mb_ul');
        item.dataset.mbOpen = String(initiallyOpen);
        const section = menu.closest('[id^="shopify-section-"]');
        submenu.id = `${section ? section.id : 'mobile-menu'}-submenu-${index}`;
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'mb-submenu-toggle';
        toggle.setAttribute('aria-controls', submenu.id);
        toggle.setAttribute('aria-label', link.textContent.trim());
        toggle.setAttribute('aria-expanded', String(initiallyOpen));
        toggle.textContent = initiallyOpen ? '−' : '+';
        item.insertBefore(toggle, submenu);
      });
      if (menu.dataset.mbBound === 'true') return;
      menu.dataset.mbBound = 'true';
      menu.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const button = target.closest('.mb-submenu-toggle');
        const link = target.closest('.mb-has-children > a');
        const placeholder = link && link.getAttribute('href') === '#';
        if (!button && !placeholder) return;
        const item = (button || link).parentElement;
        const toggle = item.querySelector(':scope > .mb-submenu-toggle');
        if (!toggle) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const open = item.dataset.mbOpen !== 'true';
        item.dataset.mbOpen = String(open);
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? '−' : '+';
      }, true);
    });
  };
  initialize();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
      $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
      })
  });

  } catch(e) { console.error(e); }
})();
})();
